import { c as _c } from "react/compiler-runtime";
export const ModalRed = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="mb-0.5 leading-tight">Pour rappel, vous pouvez être exclu d'un Club d'Affaires Dynabuy pour les manquements suivants :</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-primary text-[14px]">{t0}<ul className="list-disc pl-5 space-y-0 leading-tight"><li className="mt-0.5">En cas d'absence sur l'année civile à au moins trois réunions, sans être remplacé ou représenté ;</li><li className="mt-0.5">En cas d'absence consécutive à trois réunions, remplacement ou représentation compris.</li></ul></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};